<div class="container" *ngIf="!mobile">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a class="link font-5 uppercase" routerLink="/" (click)="closeSubMenus()">Home</a>
    </li>
    <li *ngFor="let breadcrumb of breadcrumbs; let i = index;" class="breadcrumb-item">
        <a [hidden]="i == (breadcrumbs.length - 1)" [routerLink]="[breadcrumb.url]" class="link font-5 uppercase">
            <span [innerHTML]="breadcrumbName(breadcrumb.name) | safeContent"></span>
        </a>
        <span [hidden]="i != (breadcrumbs.length - 1)" class="font-weight-bold font-5 uppercase color--primary-blue"
            [innerHTML]="breadcrumbName(breadcrumb.name, productLabel) | safeContent">
        </span>
    </li>
  </ol>
</div>
